import "./App.css";
import AppRouter from "./config/router";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { teal } from '@mui/material/colors';



const theme = createTheme({
  palette: {
    primary: { main: teal[900] }
  }
});

function App() {

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </div>
  );
}

export default App;
